// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3lHv3","buttons":"RemoveExpirationActionButtons_buttons__92zzx"};